<template>
  <ui-modal
    :show="showTeams"
    type="tag"
    :title="title"
    iconType="team"
    @close="showTeams = false"
  >
    <div class="inner-content">
      <div class="scroll-box">
        <ul class="teams-list" v-if="teamsList.length != 0">
          <li v-for="(item, key) in teamsList" :key="key">
            <div class="icon-bg">
              <div class="icon">
                <div
                  class="head"
                  :style="{
                    'background-image': `url(${
                      item?.avatar ? item.avatar || defaultAvatar : defaultAvatar
                    })`,
                  }"
                ></div>
                <div class="frame"></div>
              </div>
            </div>
            <div class="name">
              <div class="label-box">
                <span class="label-shadow">{{ item?.name ? item.name : "-" }}</span>
                <span class="label-text">{{ item?.name ? item.name : "-" }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { mapState } from "vuex";
import UiModal from "@/components/ui-modal.vue";
export default {
  components: { UiModal },
  data() {
    return {
      showTeams: false,
      teamsList: [],
      title: '参赛队伍',
      defaultAvatar: "https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png"

      
    };
  },
  computed: {
    ...mapState(["scale"]),
  },
  methods: {
    initTeams(teams, title) {
      this.teamsList = teams;
      if(title) {
        this.title = title
      }

      this.showTeams = true;
    },
    closeModal() {
      this.showTeams = false;

      // 关闭弹窗后，清空数据, 保持数据最新
      this.teamsList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/schedule/participateTeams";
</style>